/**
 * useTask — Hook for a single task by ID
 *
 * Reads from the Zustand store (no individual Firestore listener needed).
 */

import { useTaskStore } from '../store/taskStore';
import type { BackendTask } from '../types';

export function useTask(taskId: string | null): {
  task: BackendTask | null;
  loading: boolean;
} {
  const task = useTaskStore((s) =>
    taskId ? s.tasks[taskId] ?? null : null
  );
  const isConnected = useTaskStore((s) => s.isConnected);

  return {
    task,
    loading: isConnected && taskId != null && task === null,
  };
}
